import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { AuthUser } from '@/types';

export function useProfile() {
  return useQuery({
    queryKey: ['profile'],
    queryFn: () => api.get<AuthUser>('/users/me'),
    select: (res) => res.data,
  });
}
